import { Box, Button, TextField, Typography } from '@mui/material';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { CrisPartnerListGrid } from './cris-partner-list-grid';
import { Partner } from '../../../app/model/mcp/partner';
import { RootState } from '../../../app/store';
import {
    findCrisPartners,
    selectPartnerSearchResults,
    selectPartnerSearchTerm,
    setCrisPartnerSearchTerm,
} from '../cris.slice';

interface CrisPartnerSearchProps extends RouteComponentProps {
    term: string;
    results: Partner[];

    setCrisPartnerSearchTerm: (term: string) => void;

    findCrisPartners: () => void;
}

class CrisPartnerSearch extends React.Component<CrisPartnerSearchProps> {
    public render() {
        return (
            <React.Fragment>
                <Typography variant='body1' className='mb-1'>
                    Search for Partners within the system.
                </Typography>
                <form
                    onSubmit={(evt) => {
                        this.props.findCrisPartners();
                        evt.preventDefault();
                    }}
                >
                    <Box display='flex' mb={1}>
                        <Box flexGrow={1} mr={1}>
                            <TextField
                                name='term'
                                label='Partner Name'
                                variant='outlined'
                                size='small'
                                value={this.props.term}
                                fullWidth
                                onChange={(evt) => this.props.setCrisPartnerSearchTerm(evt.target.value)}
                            />
                        </Box>
                        <Button variant='contained' color='primary' type='submit'>
                            Search
                        </Button>
                    </Box>
                </form>
                <CrisPartnerListGrid
                    rows={this.props.results}
                    paginationModel={{
                        pageSize: 50,
                        page: 0,
                    }}
                    disableRowSelectionOnClick
                    density='compact'
                    pagination
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    term: selectPartnerSearchTerm(state),
    results: selectPartnerSearchResults(state),
});

const actions = { setCrisPartnerSearchTerm, findCrisPartners };

const enhanced = connect(mapStateToProps, actions)(withRouter(CrisPartnerSearch));

export { enhanced as CrisPartnerSearch };
